/**
 * 数据表格列表模块接口列表
 */

import base from './base'; // 导入接口域名列表
import axios from '../http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块

const dataList = {
  //用户表格数据
  userTable(params){
    return axios.post(`${base.baseurl.url}`,qs.stringify(Object.assign(params,{token:localStorage.getItem('token')})))
  },
}

export default dataList;



// WEBPACK FOOTER //
// ./src/api/request/dataList.js